import usHub from './us/hub';
import usServices from './us/services';
import usPrivacy from './us/privacy';
import esHub from './es/hub';
import esServices from './es/services';
import esPrivacy from './es/privacy';
import caHub from './ca/hub.json';
import caPrivacy from './ca/privacy.json';
import caAi from './ca/svc_ai.json';
import caAutomation from './ca/svc_automation.json';
import caSecurity from './ca/svc_security.json';
import caWeb from './ca/svc_web.json';
import auHub from './au/hub.json';
import auPrivacy from './au/privacy.json';
import auAi from './au/svc_ai.json';
import auAutomation from './au/svc_automation.json';
import auSecurity from './au/svc_security.json';
import auWeb from './au/svc_web.json';
import mxHub from './mx/hub.json';
import mxPrivacy from './mx/privacy.json';
import mxAi from './mx/svc_ai.json';
import mxAutomation from './mx/svc_automation.json';
import mxSecurity from './mx/svc_security.json';
import mxWeb from './mx/svc_web.json';

export const CONTENT = {
  us: { hub: usHub, services: usServices, privacy: usPrivacy },
  ca: { hub: caHub, services: { ai: caAi, automation: caAutomation, security: caSecurity, web: caWeb }, privacy: caPrivacy },
  au: { hub: auHub, services: { ai: auAi, automation: auAutomation, security: auSecurity, web: auWeb }, privacy: auPrivacy },
  es: { hub: esHub, services: esServices, privacy: esPrivacy },
  mx: { hub: mxHub, services: { ai: mxAi, automation: mxAutomation, security: mxSecurity, web: mxWeb }, privacy: mxPrivacy }
};